export default __webpack_public_path__ + "static/men-technology-zoom-plant-afe788ba5d55fff0fa475e28169a3e67.png";